import Axios from "../api/axios";
import config from "../../config";

const getGrievanceLetter = () => {
  return Axios.get(`${config.BASE_URL}grievance-letter`);
};

export default getGrievanceLetter;
